export default __webpack_public_path__ + "static/TC_Step_2-c05b28dfa43511d54a4129c1d3cf9db0.svg";